import { KEYCLOAK_STORAGE_ACCESS_TOKEN } from 'constants/keycloakConstants'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'

/**
 * Composant qui permet de gérer les routes authentifiées
 *
 * @param {Object} props Les props
 * @param {Object} props.component Le composant à afficher
 * @param {string} props.path Le chemin de la route
 *
 * @returns {React.Component} Le composant
 */
const PrivateRoute = ({ component, path }) => {
  const user = useSelector((state) => state.userReducer.user)
  const currentRoute = window.location.pathname
  const accessToken = localStorage.getItem(KEYCLOAK_STORAGE_ACCESS_TOKEN)
  const query = new URLSearchParams(window.location.search)
  const timeoutRef = React.useRef(null)

  const isMobile = () => {
    if (navigator.userAgentData) {
      return navigator.userAgentData.mobile
    }

    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  }

  const redirectToFallbackMobileUrl = () => {
    clearTimeout(timeoutRef.current)

    if (/android/i.test(navigator.userAgent)) {
      window.location.href = 'https://play.google.com/store/apps/details?id=org.union_habitat.orfi&hl=fr'
    }

    if (/iphone|ipad|ipod/i.test(navigator.userAgent)) {
      window.location.href = 'https://apps.apple.com/fr/app/orfi/id1490115920'
    }
  }

  const redirectToMobileApp = () => {
    window.location.href = query.get('mobile_redirection')

    if (!timeoutRef.current) {
      timeoutRef.current = setTimeout(() => {
        redirectToFallbackMobileUrl()
      }, 1500)
    }
  }

  const isSameRoute = () => {
    if (!path.includes(':id')) {
      return path === currentRoute
    }

    const pathWithoutId = path.split(':id')[0]
    const currentRouteWithoutIdNumber = currentRoute.split('/').slice(0, -1).join('/') + '/'

    return pathWithoutId === currentRouteWithoutIdNumber
  }

  useEffect(() => {
    if (isSameRoute() && isMobile() && query.get('mobile_redirection')) {
      redirectToMobileApp()
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  if ((!user || !user.id || !accessToken) && currentRoute === path && currentRoute !== '/' && !query.code) {
    return <Redirect to="/" />
  }

  return <Route exact path={path} render={() => component} />
}

export default PrivateRoute
